import type { NumberSettings, NumberFormat } from '../types';
import { FORMATS_SUPPORTED_FRACTION_OVERRIDES } from '../constants';

export const needsOverrideMaximumFractionDigits = (
    format: NumberFormat,
    settings: NumberSettings,
    maximumFractionDigits?: number | undefined,
): maximumFractionDigits is number => {
    if (!FORMATS_SUPPORTED_FRACTION_OVERRIDES.has(format)) return false;

    return (
        maximumFractionDigits !== undefined &&
        maximumFractionDigits !== settings.maximumFractionDigits
    )
};
